import type { ReaderItem } from "./types";

export function archiveTransition(items: ReaderItem[], archivedItemId: string): {
  remainingItems: ReaderItem[];
  adjacentItem?: ReaderItem;
} {
  const archivedIndex = items.findIndex((item) => item.id === archivedItemId);
  const remainingItems = items.filter((item) => item.id !== archivedItemId);
  if (archivedIndex < 0 || remainingItems.length === 0) return { remainingItems };
  return {
    remainingItems,
    adjacentItem: remainingItems[Math.min(archivedIndex, remainingItems.length - 1)],
  };
}
